export const SIDEBAR_TRIGGER_TITLE_CLASS = "sidebar-trigger-title";
export const SIDEBAR_TRIGGER_SUBTITLE_CLASS = "sidebar-trigger-subtitle";
